import { render, staticRenderFns } from "./Attendances.vue?vue&type=template&id=08358d83&"
import script from "./Attendances.vue?vue&type=script&lang=js&"
export * from "./Attendances.vue?vue&type=script&lang=js&"
import style0 from "./Attendances.vue?vue&type=style&index=0&id=08358d83&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports